import React from 'react';

const DeleteWhite = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5112 6.36661L14.3541 5.5812H10.6456L10.4885 6.36661H14.5112ZM16.1131 6.36661L15.8941 5.27477C15.7448 4.5362 15.1005 4.00977 14.3541 4.00977H10.6456C9.89915 4.00977 9.25488 4.5362 9.1056 5.27477L8.88658 6.36661H6.60688H5.42847V7.93804H6.60688V18.9381C6.60688 19.8024 7.31402 20.5095 8.1783 20.5095H16.8211C17.6854 20.5095 18.3925 19.8024 18.3925 18.9381V7.93804H19.5712V6.36661H18.3925H16.1131ZM8.57137 7.93804L8.57131 7.93835H16.4284L16.4283 7.93804H16.8211V18.9381H8.1783V7.93804H8.57137ZM11.7141 10.295H10.1426V16.5808H11.7141V10.295ZM13.2858 10.295H14.8572V16.5808H13.2858V10.295Z"
        fill="#3E4348"
      />
    </svg>
  );
};

export default DeleteWhite;
